import { render } from "./CaseStudy.vue?vue&type=template&id=75409c98&bindings={\"caseStudy\":\"props\"}"
import script from "./CaseStudy.vue?vue&type=script&lang=js"
export * from "./CaseStudy.vue?vue&type=script&lang=js"
script.render = render

export default script